import React from 'react';
import { ConditionOK, ConditionDefect } from '../../constants';
import { EventLogLink, EventLogText } from '../../components/Link/EventLogLink/EventLogLink';

const Event = ({ event }) => {
  switch (event.eventType) {
    //User
    case 'user.UserCreatedEvent':
      return (
        <span>
          <EventLogLink item={event.items[0]} /> joined Doams
        </span>
      );
    case 'user.UserActivatedEvent':
      return (
        <span>
          <EventLogLink item={event.items[0]} /> is now activated as a user in Doams
        </span>
      );
    case 'user.UserHomeChangedEvent':
      return (
        <span>
          User <EventLogLink item={event.items[0]} /> changed their home department to{' '}
          <EventLogLink item={event.items[1]} />
        </span>
      );

    //External
    case 'external.ExternalCreatedEvent':
      return (
        <span>
          Created external <EventLogLink item={event.items[0]} />
        </span>
      );

    case 'external.ExternalUpdatedEvent':
      return (
        <span>
          Updated external <EventLogLink item={event.items[0]} />
        </span>
      );

    case 'external.ExternalDeletedEvent':
      return (
        <span>
          Deleted external <EventLogLink item={event.items[0]} />{' '}
        </span>
      );

    case 'external.ExternalRestoredEvent':
      return (
        <span>
          Restored external <EventLogLink item={event.items[0]} />{' '}
        </span>
      );

    //Ship

    case 'ship.ShipCreatedEvent':
      return (
        <span>
          Created ship{' '}
          <EventLogLink item={event.items[0]} overrideCollectionLink={'storages'} />{' '}
        </span>
      );

    case 'ship.ShipUpdatedEvent':
      return (
        <span>
          Updated ship <EventLogLink item={event.items[0]} />{' '}
        </span>
      );

    case 'ship.ShipDeletedEvent':
      return (
        <span>
          Deleted ship <EventLogLink item={event.items[0]} />{' '}
        </span>
      );

    //Department
    case 'department.DepartmentCreatedEvent':
      return (
        <span>
          Created department <EventLogLink item={event.items[0]} /> at{' '}
          <EventLogLink item={event.items[1]} />
        </span>
      );

    case 'department.DepartmentDeletedEvent':
      return (
        <span>
          Deleted department <EventLogLink item={event.items[0]} /> at{' '}
          <EventLogLink item={event.items[1]} />
        </span>
      );

    case 'department.DepartmentUpdatedEvent':
      return (
        <span>
          Renamed department <EventLogLink item={event.items[0]} />
        </span>
      );

    case 'department.DepartmentRestoredEvent':
      return (
        <span>
          Restored department <EventLogLink item={event.items[0]} /> at{' '}
          <EventLogLink item={event.items[1]} />
        </span>
      );

    //Storage
    case 'storage.StorageCreatedEvent':
      return (
        <span>
          Created storage <EventLogLink item={event.items[0]} />
        </span>
      );

    case 'storage.StorageUpdatedEvent':
      return (
        <span>
          Updated storage <EventLogLink item={event.items[0]} />
        </span>
      );

    case 'storage.StorageDeletedEvent':
      return (
        <span>
          Deleted storage <EventLogLink item={event.items[0]} />
        </span>
      );

    case 'storage.StorageRestoredEvent':
      return (
        <span>
          Restored storage <EventLogLink item={event.items[0]} /> in{' '}
          <EventLogLink item={event.items[1]} />
        </span>
      );
    //Office
    case 'office.OfficeCreatedEvent':
      return (
        <span>
          Created office <EventLogLink item={event.items[0]} />
        </span>
      );

    case 'office.OfficeUpdatedEvent':
      return (
        <span>
          Updated office <EventLogLink item={event.items[0]} />
        </span>
      );

    case 'office.OfficeDeletedEvent':
      return (
        <span>
          Deleted office <EventLogLink item={event.items[0]} />{' '}
        </span>
      );

    case 'office.OfficeRestoredEvent':
      return (
        <span>
          Restored office <EventLogLink item={event.items[0]} />{' '}
        </span>
      );

    //FILE
    case 'file.FileDeletedEvent':
      return (
        <span>
          Deleted <EventLogText item={event.items[0]} /> from{' '}
          <EventLogLink item={event.items[1]} />{' '}
        </span>
      );

    case 'file.FileUploadedEvent':
      return (
        <span>
          Uploaded file <EventLogText item={event.items[0]} /> to{' '}
          <EventLogLink item={event.items[1]} />
        </span>
      );

    //MANIFESTS
    case 'manifest.ManifestCreatedEvent':
      return (
        <span>
          Created manifest <EventLogLink item={event.items[0]} />
        </span>
      );

    case 'manifest.ManifestReceivedEvent':
      return (
        <span>
          {' '}
          Manifest <EventLogLink item={event.items[0]} /> received at{' '}
          <EventLogLink item={event.items[1]} />
        </span>
      );

    case 'manifest.ManifestSentEvent':
      return (
        <span>
          Sent manifest: <EventLogLink item={event.items[0]} /> from{' '}
          <EventLogLink item={event.items[1]} /> to <EventLogLink item={event.items[2]} />
        </span>
      );

    case 'manifest.ManifestDeletedEvent':
      return (
        <span>
          Deleted manifest <EventLogLink item={event.items[0]} />
        </span>
      );
    //PRODUCTS
    case 'product.ProductCreatedEvent':
      return (
        <span>
          {' '}
          Created model <EventLogLink item={event.items[0]} />
        </span>
      );

    case 'product.ProductLogoUpdatedEvent':
      return (
        <span>
          {' '}
          Uploaded new logo for model <EventLogLink item={event.items[0]} />
        </span>
      );

    case 'product.ProductDeletedEvent':
      return (
        <span>
          {' '}
          Deleted model <EventLogLink item={event.items[0]} />
        </span>
      );

    case 'product.ProductRestoredEvent':
      return (
        <span>
          {' '}
          Restored model <EventLogLink item={event.items[0]} />
        </span>
      );

    case 'product.ProductUpdatedEvent':
      return (
        <span>
          {' '}
          Updated model <EventLogLink item={event.items[0]} />
        </span>
      );

    //ASSETS
    case 'asset.AssetUpdatedEvent':
      return (
        <span>
          {' '}
          Updated <EventLogLink item={event.items[0]} />
        </span>
      );

    case 'asset.AssetCreatedEvent':
      return (
        <span>
          {' '}
          Created asset <EventLogLink item={event.items[0]} />
        </span>
      );

    case 'asset.AssetDeletedEvent':
      return (
        <span>
          {' '}
          Deleted asset <EventLogLink item={event.items[0]} />
        </span>
      );

    case 'asset.AssetRestoredEvent':
      return (
        <span>
          {' '}
          Restored asset <EventLogLink item={event.items[0]} />
        </span>
      );

    case 'asset.AssetShippedEvent':
      return (
        <span>
          Asset <EventLogLink item={event.items[0]} /> shipped in{' '}
          <EventLogLink item={event.items[1]} /> from <EventLogLink item={event.items[2]} /> to{' '}
          <EventLogLink item={event.items[3]} />{' '}
        </span>
      );

    case 'asset.AssetReceivedEvent':
      return (
        <span>
          Received asset <EventLogLink item={event.items[0]} /> at{' '}
          <EventLogLink item={event.items[1]} /> as part of <EventLogLink item={event.items[2]} />
        </span>
      );

    case 'asset.AssetMovedEvent':
      return (
        <span>
          Moved <EventLogLink item={event.items[0]} /> from <EventLogLink item={event.items[2]} />{' '}
          to <EventLogLink item={event.items[1]} />
        </span>
      );

    case 'asset.AssetCommentDeletedEvent':
      return (
        <span>
          Deleted theyre comment on <EventLogLink item={event.items[0]} />
        </span>
      );

    case 'asset.AssetCommentAddedEvent':
      return (
        <span>
          Added comment to <EventLogLink item={event.items[0]} />{' '}
        </span>
      );

    case 'asset.AssetCalibratedEvent':
      return (
        <span>
          Updated calibration to <EventLogText item={event.items[1]} /> for{' '}
          <EventLogLink item={event.items[0]} />
        </span>
      );

    case 'asset.AssetConditionSetEvent':
      return (
        <span>
          Changed condition to {parseInt(event.items[1].Value) === ConditionOK && 'Operational'}
          {parseInt(event.items[1].Value) === ConditionDefect && (
            <span>"Need Service"</span>
          )} for <EventLogLink item={event.items[0]} />
        </span>
      );

    default:
      return <div>unknown event type: {event.eventType}</div>;
  }
};

export default Event;
